import Button from '@/components/elements/Button';
import Icon, { Icons } from '@/components/elements/Icon';
import Modal from '@/components/modules/Modal';
import { useTranslations } from 'use-intl';

export const CreateVaultOpenseaModal = ({
  onCancel,
}: {
  onCancel: () => void;
}) => {
  const t = useTranslations('CreateVault.OpenseaModal');

  return (
    <Modal
      size="md"
      clickOffToClose={false}
      showCloseButton={false}
      justify="center"
    >
      <div className="text-center p-6">
        <h1 className="font-bold text-xl mb-4 flex justify-center items-center">
          <Icon
            name={Icons.EXCLAMATION_TRIANGLE}
            className="text-orange-500 mr-2"
          />
          {t('title')}
        </h1>
        <p className="mb-4">{t('text')}</p>
        <p className="mb-4">{t('help')}</p>
        <Button onClick={onCancel} className="inline-flex">
          {t('understand')}
        </Button>
      </div>
    </Modal>
  );
};

export default CreateVaultOpenseaModal;
